/**
 * Roster import is a district admin screen. It is shown only when the
 * district flag attendance.ota_opt2.import is on. A missing flag is off.
 * The caller's union does not matter here; employee screens use that check.
 */

export const ROSTER_IMPORT_FLAG = 'attendance.ota_opt2.import';
export const ROSTER_IMPORT_PERMISSION = 'attendance.scheduling.edit';
export const ROSTER_IMPORT_HREF = '/attendance/roster-import';

export function rosterImportFlagOn(flagPayload) {
  const keys = flagPayload && Array.isArray(flagPayload.keys) ? flagPayload.keys : [];
  return keys.includes(ROSTER_IMPORT_FLAG);
}

/**
 * Menu visibility. Super admins follow the same flag as everyone else.
 * They still need the flag on; the permission check is the only bypass.
 */
export function rosterImportNavVisible({ flagOn, permissions, isSuperAdmin } = {}) {
  if (!flagOn) return false;
  if (isSuperAdmin) return true;
  return (permissions || []).includes(ROSTER_IMPORT_PERMISSION);
}
